import React from 'react'
import { DraftTableCon, DraftCol } from './styles'
import { DraftPick } from '../../Api/Draft/draft.types'
import { getTeamIc, getFullTeamName } from '../../Utils'
import { Img } from '../../Components/Image/Img'
import { TableHeader } from '../../Components/Tables/TableHeader'

type DraftTableParams = {
  picks: DraftPick[]
}

export const DraftTable: React.FC<React.PropsWithChildren<DraftTableParams>> = ({ picks }) => {

  const renderTeamRow = (teamId: string) => {
    const fullName = getFullTeamName(teamId)
    if (!fullName) {
      return <div />
    }
    const teamImgUrl = getTeamIc(fullName)
    return (
      <DraftCol>
        <Img src={teamImgUrl} alt={`${fullName} logo`}/>
        <span>{fullName}</span>
      </DraftCol>
    )
  }

  return (
    <DraftTableCon>
      {picks.length > 0 && (
        <div className='innerTableCon'>
            <table className='draftTable'>
              <thead>
                <tr>
                  <TableHeader ariaLabel="Round">Round</TableHeader>
                  <TableHeader ariaLabel="Team">Team</TableHeader>
                  <TableHeader ariaLabel="Player">Player</TableHeader>
                  <TableHeader ariaLabel="Position">Position</TableHeader>
                  <TableHeader ariaLabel="College">College</TableHeader>
                  <TableHeader ariaLabel="Overall Pick">Overall Pick</TableHeader>
                </tr>
              </thead>
              <tbody>
                {picks.map((pk, idx) => (
                  <tr key={`${pk.round}${pk.roundPick}${idx}`}>
                    <td>{`RD ${pk.round}, PK ${pk.roundPick}`}</td>
                    <td>{renderTeamRow(pk.teamId)}</td>
                    <td>
                      <DraftCol>
                        <span>{pk.playerName}</span>
                      </DraftCol>
                    </td>
                    <td>{pk.position}</td>
                    <td>{pk.college}</td>
                    <td>{pk.overallPick}</td>
                  </tr>
                ))}
              </tbody>
            </table>
        </div>
      )}
    </DraftTableCon>
  )
}
